var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1662H12.5M14.1667 17.4995H5.83333C4.94928 17.4995 4.10143 17.1483 3.47631 16.5232C2.85119 15.8981 2.5 15.0502 2.5 14.1662V8.92286C2.49999 8.3497 2.64776 7.78623 2.92906 7.28685C3.21035 6.78747 3.61566 6.36906 4.10583 6.07202L8.2725 3.54702C8.79343 3.23135 9.39089 3.06445 10 3.06445C10.6091 3.06445 11.2066 3.23135 11.7275 3.54702L15.8942 6.07202C16.3842 6.36899 16.7895 6.78727 17.0707 7.28649C17.352 7.78571 17.4999 8.34901 17.5 8.92202V14.1662C17.5 15.0502 17.1488 15.8981 16.5237 16.5232C15.8986 17.1483 15.0507 17.4995 14.1667 17.4995Z",
    stroke: "#6EAF1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.c18804d4bab2c9bab5d21928b3716d76.svg";
export { ForwardRef as ReactComponent };